import React, { useState, useEffect } from "react";
import ajax from "superagent";
import EventsList from "./EventsList";

const BrowsingHistoryEvents = () => {
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    ajax
      .get("api/v1/search_events/history")
      .then(response => {
        setLoading(false);
        setEvents(response.body.events);
      })
      .catch(err => {
        setLoading(false);
        setError(err.message);
      });
  }, []);

  return <EventsList loading={loading} events={events} />;
};

export default BrowsingHistoryEvents;
